import { TWorkflowDefinition, TWorkflowStepDefinition } from '@commenda/types';

import { TStepPickerOption } from '../types/step-picker';

export class WorkflowStepPickerHelper {
  static readonly STRANDED_STEP_GROUP_LABEL = 'No longer runs before this step';

  // A picked step that has since been deleted or rewired stays listed under its own heading rather than vanishing,
  // so the author can see and undo a pick that publish would refuse.
  static buildStepPickerOptions(
    workflow: Readonly<TWorkflowDefinition> | null,
    upstreamSteps: readonly TWorkflowStepDefinition[],
    pickedStepIds: readonly string[]
  ): TStepPickerOption[] {
    const upstreamIds = new Set(upstreamSteps.map((step) => step.id));
    const strandedOptions = pickedStepIds
      .filter((stepId) => !upstreamIds.has(stepId))
      .map((stepId) => ({
        value: stepId,
        label:
          workflow?.steps.find((step) => step.id === stepId)?.name || stepId,
        group: WorkflowStepPickerHelper.STRANDED_STEP_GROUP_LABEL,
        isStranded: true,
      }));

    return [
      ...upstreamSteps.map((step) => ({
        value: step.id,
        label: step.name || step.id,
        isStranded: false,
      })),
      ...strandedOptions,
    ];
  }
}
